import React, { Fragment, useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Container
} from 'reactstrap';
import { connect } from 'react-redux';
import Login from './auth/Login';
import Logout from './auth/Logout';
import NotificationPopup from './NotificationPopup';
import { IAppNavbar, IAuthReduxProps } from '../types/interfaces';
import { Redirect } from 'react-router-dom';

const AppNavbar = ({ auth }: IAppNavbar) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(!isOpen);

  const authLinks = (
    <Fragment>
      <NavItem>
        <span className="navbar-text mr-3">
          <strong data-letters={auth?.user?.name?.charAt(0) || ""} className="fullEllipsis">
            {auth?.user ? `Bienvenue ${auth.user.name}` : ''}
          </strong>
        </span>
      </NavItem>
      <NavItem>
        <NotificationPopup />
      </NavItem>
      <NavItem>
        <Logout />
      </NavItem>
    </Fragment>
  );

  return (
    <div className="navbar-parent"/* style={auth && auth.user ? {} : {display: "none"}}*/>
      <Navbar expand="sm"/* className="mb-4"*/>
        <Container>
          {/* <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} /> */}
          <NavbarBrand href="/"><img src="/images/logo_bg_prod.png" height="40" width="auto" /></NavbarBrand>
          {(false && process.env.REACT_APP_NODE_ENV !== "production") && <div style={{color: "red", position: "absolute", right: 5}}>DEBUG MODE</div>}
          <Nav className="ml-auto d-flex align-items-center" style={{flexDirection: "row", gap: "1rem"}} navbar>
            {auth?.isAuthenticated && (
              <>
                <div className="d-flex align-items-center">
                  <strong
                    data-letters={auth.user?.name?.charAt(0) || ""}
                    className="me-1"
                    title={auth.user?.name}
                  />
                  <span className="d-none d-sm-inline text-white ml-2">
                    Bienvenue {auth.user.name}
                  </span>
                </div>
                <NotificationPopup />
                <Logout />
              </>
            )}
          </Nav>
        </Container>
      </Navbar>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(AppNavbar);
